"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Package = exports.SupportedEvents = void 0;
exports.SupportedEvents = [
    'autopostSuccess',
    'autopostFail',
    'postSuccess',
    'postFail'
];
exports.Package = require('../../package.json');
